var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSwitchr = function SvgSwitchr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    fill: "#cacaca"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.819 66.709c-.995 0-1.794.808-1.794 1.791a1.793 1.793 0 003.587 0 1.78 1.78 0 00-1.793-1.791zM90.472 42H45.528C30.908 42 19 53.885 19 68.5S30.908 95 45.528 95h44.944C105.102 95 117 83.115 117 68.5S105.103 42 90.472 42zM54.156 71.93h-5.27v5.265a3.43 3.43 0 01-3.434 3.43 3.424 3.424 0 01-3.434-3.43V71.93h-5.27a3.43 3.43 0 110-6.86h5.27v-5.265a3.43 3.43 0 013.434-3.43 3.424 3.424 0 013.434 3.43v5.265h5.27a3.43 3.43 0 110 6.86zm21.848 4.238c-4.231 0-7.676-3.44-7.676-7.668 0-4.227 3.445-7.668 7.676-7.668 4.232 0 7.677 3.44 7.677 7.668 0 4.227-3.445 7.668-7.677 7.668zm19.815 0c-4.232 0-7.677-3.44-7.677-7.668 0-4.227 3.445-7.668 7.677-7.668 4.232 0 7.676 3.44 7.676 7.668 0 4.227-3.444 7.668-7.676 7.668zm-19.815-9.46c-.995 0-1.793.809-1.793 1.792a1.793 1.793 0 003.587 0c0-.994-.798-1.791-1.794-1.791z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgSwitchr;